
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Badge } from '../ui/badge';
import { ChevronDown } from 'lucide-react';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger
} from '../ui/dropdown-menu';

interface DesktopMenuProps {
  handleNavigation: (anchor?: string) => void;
}

export const DesktopMenu: React.FC<DesktopMenuProps> = ({ handleNavigation }) => {
  const location = useLocation();
  
  return (
    <nav className="hidden md:flex items-center space-x-8">
      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center gap-1 text-brand-darkgrey hover:text-brand-blue transition-colors focus:outline-none">
          Offerings
          <ChevronDown className="h-4 w-4" />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem asChild>
            <Link to="/subscription-model" onClick={() => handleNavigation()}>
              Hire yourself
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/assisted-sourcing-models" onClick={() => handleNavigation()}>
              Managed hiring (Assisted model)
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a href="https://cutshort.io/ai-screener" target="_blank" rel="noopener noreferrer">
              AI Screener
            </a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      
      {location.pathname === '/' ? (
        <a href="#plans" className="text-brand-darkgrey hover:text-brand-blue transition-colors">
          Pricing
        </a>
      ) : (
        <Link to="/#plans" className="text-brand-darkgrey hover:text-brand-blue transition-colors" onClick={() => handleNavigation('#plans')}>
          Pricing
        </Link>
      )}
      
      {/* <Link 
        to="/personas/cutshort-for-ta-leaders" 
        className="group flex items-center gap-2 relative"
        onClick={() => handleNavigation()}
      >
        <span className={location.pathname === '/personas/cutshort-for-ta-leaders' 
          ? 'text-brand-blue font-medium' 
          : 'bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-purple-500 font-medium hover:opacity-90 transition-opacity'
        }>
          For TA Leaders
          <Badge 
            variant="outline" 
            className="absolute -top-2 -right-4 text-[7px] h-3 px-0.5 border-brand-blue text-brand-blue"
          >
            New
          </Badge>
        </span>
      </Link> */}
      
      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center gap-1 text-brand-darkgrey hover:text-brand-blue transition-colors focus:outline-none">
          Resources
          <ChevronDown className="h-4 w-4" />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem asChild>
            <Link to="/events" onClick={() => handleNavigation()}>
              Events
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a href="https://newsletter.cutshort.io" target="_blank" rel="noopener noreferrer">
              Our newsletter
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/reports" onClick={() => handleNavigation()} className="flex items-center gap-2">
              Reports
              <Badge 
                variant="outline" 
                className="text-[7px] h-3 px-0.5 border-brand-blue text-brand-blue"
              >
                New
              </Badge>
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      
      <Link 
        to="/startup-offering"
        className="group flex items-center gap-2 relative"
        onClick={() => handleNavigation()}
      >
        <span className={location.pathname === '/startup-offering' 
          ? 'text-brand-blue font-medium' 
          : 'text-brand-darkgrey hover:text-brand-blue transition-colors'
        }>
          For early stage startups
          <Badge 
            variant="outline" 
            className="absolute -top-2 -right-4 text-[7px] h-3 px-0.5 border-brand-blue text-brand-blue"
          >
            New
          </Badge>
        </span>
      </Link>
    </nav>
  );
};
